import { ONBOARDING_ATTEMPTS } from "../onboardingConstants";
import { OnboardingTutorialProfitLoss } from "./OnboardingProfitLoss";
import { OnboardingTutorialClosePosition } from "./OnboardingTutorialClosePosition";
import {
    ONBOARDING_TUTORIAL_STEP_NAMES,
    PRELOAD_IMAGES_URLS_ONBOARDING_INITIAL,
    PRELOAD_IMAGES_URLS_ONBOARDING_REPEATED
} from "./onboardingTutorialConstants";
import { OnboardingTutorialLots } from "./OnboardingTutorialLots";
import { OnboardingTutorialMarginImpact } from "./OnboardingTutorialMarginImpact";
import { OnboardingTutorialOpenPosition } from "./OnboardingTutorialOpenPosition";
import { OnboardingTutorialPortfolio } from "./OnboardingTutorialPortfolio";
import { OnboardingTutorialSelectOrderSide } from "./OnboardingTutorialSelectOrderSide";
import { OnboardingTutorialWatchList } from "./OnboardingTutorialWatchList";

export const ONBOARDING_TUTORIAL_STEPS = {
    [ONBOARDING_TUTORIAL_STEP_NAMES.CLOSE_POSITION]: {
        component: OnboardingTutorialClosePosition,
        name: ONBOARDING_TUTORIAL_STEP_NAMES.CLOSE_POSITION,
    },
    [ONBOARDING_TUTORIAL_STEP_NAMES.LOTS]: {
        component: OnboardingTutorialLots,
        name: ONBOARDING_TUTORIAL_STEP_NAMES.LOTS,
    },
    [ONBOARDING_TUTORIAL_STEP_NAMES.MARGIN_IMPACT]: {
        component: OnboardingTutorialMarginImpact,
        name: ONBOARDING_TUTORIAL_STEP_NAMES.MARGIN_IMPACT,
    },
    [ONBOARDING_TUTORIAL_STEP_NAMES.OPEN_POSITION]: {
        component: OnboardingTutorialOpenPosition,
        name: ONBOARDING_TUTORIAL_STEP_NAMES.OPEN_POSITION,
    },
    [ONBOARDING_TUTORIAL_STEP_NAMES.PORTFOLIO]: {
        component: OnboardingTutorialPortfolio,
        name: ONBOARDING_TUTORIAL_STEP_NAMES.PORTFOLIO,
    },
    [ONBOARDING_TUTORIAL_STEP_NAMES.PROFIT_LOSS]: {
        component: OnboardingTutorialProfitLoss,
        name: ONBOARDING_TUTORIAL_STEP_NAMES.PROFIT_LOSS,
    },
    [ONBOARDING_TUTORIAL_STEP_NAMES.SELECT_ORDER_SIDE]: {
        component: OnboardingTutorialSelectOrderSide,
        name: ONBOARDING_TUTORIAL_STEP_NAMES.SELECT_ORDER_SIDE,
    },
    [ONBOARDING_TUTORIAL_STEP_NAMES.WATCHLIST]: {
        component: OnboardingTutorialWatchList,
        name: ONBOARDING_TUTORIAL_STEP_NAMES.WATCHLIST,
    },
}

export const ONBOARDING_TUTORIAL_STEP_NAMES_INITIAL = [
    ONBOARDING_TUTORIAL_STEP_NAMES.WATCHLIST,
    ONBOARDING_TUTORIAL_STEP_NAMES.SELECT_ORDER_SIDE,
    ONBOARDING_TUTORIAL_STEP_NAMES.OPEN_POSITION,
    ONBOARDING_TUTORIAL_STEP_NAMES.PORTFOLIO,
    ONBOARDING_TUTORIAL_STEP_NAMES.CLOSE_POSITION,
];

export const ONBOARDING_TUTORIAL_STEP_NAMES_REPEATED = [
    ONBOARDING_TUTORIAL_STEP_NAMES.WATCHLIST,
    ONBOARDING_TUTORIAL_STEP_NAMES.SELECT_ORDER_SIDE,
    ONBOARDING_TUTORIAL_STEP_NAMES.LOTS,
    ONBOARDING_TUTORIAL_STEP_NAMES.MARGIN_IMPACT,
    ONBOARDING_TUTORIAL_STEP_NAMES.OPEN_POSITION,
    ONBOARDING_TUTORIAL_STEP_NAMES.PORTFOLIO,
    ONBOARDING_TUTORIAL_STEP_NAMES.PROFIT_LOSS,
    ONBOARDING_TUTORIAL_STEP_NAMES.CLOSE_POSITION,
];

export const ONBOARDING_TUTORIAL_CONFIG = {
    [ONBOARDING_ATTEMPTS.INITIAL]: {
        images: PRELOAD_IMAGES_URLS_ONBOARDING_INITIAL,
        stepNames: ONBOARDING_TUTORIAL_STEP_NAMES_INITIAL,
    },
    [ONBOARDING_ATTEMPTS.REPEATED]: {
        images: PRELOAD_IMAGES_URLS_ONBOARDING_REPEATED,
        stepNames: ONBOARDING_TUTORIAL_STEP_NAMES_REPEATED,
    },
}

export const getOnboardingTutorialConfigInfo = (attempt = ONBOARDING_ATTEMPTS.INITIAL) => {
    const config = ONBOARDING_TUTORIAL_CONFIG[attempt] ||
        ONBOARDING_TUTORIAL_CONFIG[ONBOARDING_ATTEMPTS.INITIAL];
    const steps = config.stepNames.map(stepName => ONBOARDING_TUTORIAL_STEPS[stepName])
    return {steps, images: config.images}
}
